import './Portfolio.css';
import React from 'react';
import { useEffect, useState } from 'react';
import { FaTasks, FaHistory } from 'react-icons/fa';
import { ImUsers } from 'react-icons/im';
import { FaUsers } from 'react-icons/fa';
const Portfolionum = () => {
    const [obj, setObj] = useState([]);
    const fetchPortfolio = async () => {
        await fetch("https://api.aizonixsolutions.com/api/portfolio/")
            .then((res) => res.json())
            .then((obj) => setObj(obj))
            .catch((err) => {
                console.log(err);
            });
    };
    useEffect(() => {
        fetchPortfolio();
    }, []);


    return (
        <>
            <div className="numContainer" >
                {obj.map((item) => (
                    <ul key={item.id} className="text-center row">
                        <li className="col-sm-3 ">
                            <FaTasks style={{ width: '40px', height: "40px", marginBottom: "10px" }} />
                            <h1 style={{ color: 'black', fontWeight: 'bold' }} >{item.projects}<sup style={{ color: '#1E978C', fontSize: '40px' }}>+</sup></h1>

                            <p > Successful Projects </p>
                        </li>
                        <li className="col-sm-3">
                            <ImUsers style={{ width: '40px', height: "40px", marginBottom: "10px" }} />
                            <h1 style={{ color: 'black', fontWeight: 'bold' }}>{item.employees}<sup style={{ color: '#1E978C', fontSize: '40px' }}>+</sup></h1>

                            <p > Skilled Developers & Experts </p>
                        </li>
                        <li className="col-sm-3">
                            <FaUsers style={{ width: '40px', height: "40px", marginBottom: "10px" }} />
                            <h1 style={{ color: 'black', fontWeight: 'bold' }}>{item.clients}<sup style={{ color: '#1E978C', fontSize: '40px' }}>+</sup></h1>

                            <p > Satisfied Clients Worldwide </p>
                        </li>
                        <li className="col-sm-3">
                            <FaHistory style={{ width: '40px', height: "40px", marginBottom: "10px" }} />
                            <h1 style={{ color: 'black', fontWeight: 'bold' }}>{item.yearsOfExperience}<sup style={{ color: '#1E978C', fontSize: '40px' }}>+</sup></h1>

                            <p>Years of Experience in the Industry</p>
                        </li>
                    </ul>
                ))}
            </div>
        </>
    )
}

export default Portfolionum;